module.exports = __webpack_public_path__ + "img/educationalPeriods.88a426fb.svg";